__turbopack_context__.v({
  "checked": "Switch-module-scss-module__uXSjba__checked",
  "container": "Switch-module-scss-module__uXSjba__container",
  "disabled": "Switch-module-scss-module__uXSjba__disabled",
  "element": "Switch-module-scss-module__uXSjba__element",
  "reverse": "Switch-module-scss-module__uXSjba__reverse",
  "scaleInCenter": "Switch-module-scss-module__uXSjba__scaleInCenter",
  "switch": "Switch-module-scss-module__uXSjba__switch",
});
